var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.77143 5.70857C9.77143 5.28252 9.42605 4.93714 9 4.93714C8.57395 4.93714 8.22857 5.28252 8.22857 5.70857H9H9.77143ZM9 9H8.22857C8.22857 9.2046 8.30985 9.40081 8.45452 9.54548L9 9ZM10.1002 11.1912C10.4015 11.4925 10.8899 11.4925 11.1912 11.1912C11.4925 10.8899 11.4925 10.4015 11.1912 10.1002L10.6457 10.6457L10.1002 11.1912ZM17.2286 9H16.4571C16.4571 13.1185 13.1185 16.4571 9 16.4571V17.2286V18C13.9706 18 18 13.9706 18 9H17.2286ZM9 17.2286V16.4571C4.88153 16.4571 1.54286 13.1185 1.54286 9H0.771429H0C0 13.9706 4.02944 18 9 18V17.2286ZM0.771429 9H1.54286C1.54286 4.88153 4.88153 1.54286 9 1.54286V0.771429V0C4.02944 0 0 4.02944 0 9H0.771429ZM9 0.771429V1.54286C13.1185 1.54286 16.4571 4.88153 16.4571 9H17.2286H18C18 4.02944 13.9706 0 9 0V0.771429ZM9 5.70857H8.22857V9H9H9.77143V5.70857H9ZM9 9L8.45452 9.54548L10.1002 11.1912L10.6457 10.6457L11.1912 10.1002L9.54548 8.45452L9 9Z",
    fill: "#A5B4CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.d7943a6f9553ffcde7c89f9b7c438967.svg";
export { ForwardRef as ReactComponent };